import { createSelector } from '@ngrx/store';
import { getSpinnerState } from '../../core/store/store.selectors';
import { SpinnerInterface } from './spinner.state';

export const getSpinner = createSelector(
  getSpinnerState,
  (state: SpinnerInterface) => state.showSpinner
);
